module.exports = __webpack_public_path__ + "static/media/GBPUSD.db56af79.svg";